<template>
  <h4 class="detail-title-lv2">
    {{ title }}<slot />
  </h4>
</template>

<style scoped lang="scss">
@use "@/styles/preview/sp/base" as *;
</style>

<script>
export default {
  props: {
    title: {
      type: String,
      required: true
    }
  }
}
</script>
